module.exports = __webpack_public_path__ + "static/media/aperitif-icon.0ce3541e.svg";